import React from 'react';
import { Box, Button, Paper, Stack } from '@mui/material';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';

export default function BatchActionBar({ archived, onAssignTest, onAssignPlan, onArchive, onUnarchive }) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        mb: 3,
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'action.hover',
      }}
    >
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={1.5}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        justifyContent="space-between"
      >
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} flexWrap="wrap" useFlexGap sx={{ flex: 1 }}>
          <Button
            variant="contained"
            size="large"
            disabled={archived}
            onClick={onAssignTest}
            startIcon={<AssignmentTurnedInIcon />}
            sx={{
              fontWeight: 600,
              textTransform: 'none',
              px: 2.5,
              py: 1,
              boxShadow: (t) => (archived ? 'none' : t.shadows[4]),
              '&:focus-visible': { outline: '2px solid', outlineOffset: 2, outlineColor: 'primary.main' },
            }}
          >
            Assign test to batch
          </Button>
          <Button
            variant="outlined"
            size="large"
            disabled={archived}
            onClick={onAssignPlan}
            startIcon={<SchoolOutlinedIcon />}
            sx={{
              fontWeight: 600,
              textTransform: 'none',
              px: 2.5,
              py: 1,
              borderWidth: 2,
              '&:hover': { borderWidth: 2 },
              '&:focus-visible': { outline: '2px solid', outlineOffset: 2, outlineColor: 'primary.main' },
            }}
          >
            Assign exam prep plan
          </Button>
        </Stack>
        <Box sx={{ alignSelf: { xs: 'stretch', sm: 'center' } }}>
          {archived ? (
            <Button
              variant="text"
              color="primary"
              onClick={onUnarchive}
              sx={{ fontWeight: 600, textTransform: 'none' }}
            >
              Restore batch
            </Button>
          ) : (
            <Button
              variant="text"
              color="warning"
              onClick={onArchive}
              startIcon={<Inventory2OutlinedIcon />}
              sx={{
                fontWeight: 600,
                textTransform: 'none',
                opacity: 0.92,
                '&:hover': { opacity: 1, bgcolor: 'warning.light', color: 'warning.contrastText' },
                '&:focus-visible': { outline: '2px solid', outlineOffset: 2, outlineColor: 'warning.main' },
              }}
            >
              Archive batch
            </Button>
          )}
        </Box>
      </Stack>
    </Paper>
  );
}
